/**
 *
 * DialogActions
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { TertiaryButton } from 'components/v2/Button';
import { StyledDialogActions } from './DialogActions.styles';

export const DialogActionBackButton = styled(TertiaryButton)`
  && {
    margin-right: auto !important;
  }
`;

function DialogActions(props) {
  return <StyledDialogActions {...props} />;
}

export default memo(DialogActions);
